import { cn } from "@/lib/utils";

function AppleIcon({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 384 512" fill="currentColor" className={className}>
      <path d="M318.7 268.7c-.2-36.7 16.4-64.4 50-84.8-18.8-26.9-47.2-41.7-84.7-44.6-35.5-2.8-74.3 20.7-88.5 20.7-15 0-49.4-19.7-76.4-19.7C63.3 141.2 4 184.8 4 273.5q0 39.3 14.4 81.2c12.8 36.7 59 126.7 107.2 125.2 25.2-.6 43-17.9 75.8-17.9 31.8 0 48.3 17.9 76.4 17.9 48.6-.7 90.4-82.5 102.6-119.3-65.2-30.7-61.7-90-61.7-91.9zm-56.6-164.2c27.3-32.4 24.8-62.1 24-72.5-24.1 1.4-52 16.4-67.9 34.9-17.5 19.8-27.8 44.3-25.6 71.9 26.1 2 49.9-11.4 69.5-34.3z" />
    </svg>
  );
}

function AndroidIcon({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 576 512" fill="currentColor" className={className}>
      <path d="M420.55 301.93a24 24 0 1 1 24-24 24 24 0 0 1-24 24m-265.1 0a24 24 0 1 1 24-24 24 24 0 0 1-24 24m273.7-144.48 47.94-83a10 10 0 1 0-17.27-10l-48.54 84.07a306.6 306.6 0 0 0-123.28-25.69 306.6 306.6 0 0 0-123.28 25.69L116.18 64.45a10 10 0 1 0-17.27 10l47.94 83C64.53 202.22 8.24 285.55 0 384h576c-8.24-98.45-64.54-181.78-146.85-226.55" />
    </svg>
  );
}

export function PlatformIcon({
  projectType,
  className,
}: {
  projectType: string;
  className?: string;
}) {
  const isAndroid =
    projectType === "android_native" ||
    projectType === "flutter_android" ||
    projectType === "react_native_android";
  const isIOS = projectType === "flutter" || projectType === "ios_native" || projectType === "react_native";

  if (isAndroid) {
    return (
      <span className={cn("flex size-5 items-center justify-center rounded-full bg-[#3ddc84] ring-2 ring-card", className)}>
        <AndroidIcon className="size-3 text-black" />
      </span>
    );
  }

  if (isIOS) {
    return (
      <span className={cn("flex size-5 items-center justify-center rounded-full bg-zinc-700 ring-2 ring-card", className)}>
        <AppleIcon className="size-2.5 text-white" />
      </span>
    );
  }

  return null;
}
